import { render, staticRenderFns } from "./Catalogs.vue?vue&type=template&id=c6c23e4c&scoped=true&lang=html&"
import script from "./Catalogs.vue?vue&type=script&lang=js&"
export * from "./Catalogs.vue?vue&type=script&lang=js&"
import style0 from "./Catalogs.vue?vue&type=style&index=0&id=c6c23e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c23e4c",
  null
  
)

export default component.exports